import { IgetCatalogReferencesAPIBody } from 'api/endpoints/catalogUpdateReferences/catalogUpdateReferences.response.interface';
import {
  IColumnsSelectOrderCatalogUpdateState,
  IInitialCatalogUpdateReferencesState,
} from 'interfaces/catalogUpdateReferences.interface';

const initialColumnsOrder: Record<string, IColumnsSelectOrderCatalogUpdateState> = {
  reference: {
    show: true,
    required: true,
    order: 1,
    updateable: false,
    dbField: 'reference',
  },
  color_code: {
    show: true,
    required: true,
    order: 2,
    updateable: true,
    dbField: 'color_id',
  },
  color: { show: true, required: false, order: 3, updateable: true, dbField: 'color' },
  size: { show: true, required: true, order: 4, updateable: true, dbField: 'size_id' },
  ean: { show: true, required: true, order: 5, updateable: true, dbField: 'ean' },
  product_description: {
    show: true,
    required: false,
    order: 6,
    updateable: true,
    dbField: 'product_description',
  },
  pvi: { show: true, required: false, order: 7, updateable: true, dbField: 'pvi' },
  pvpr: { show: true, required: false, order: 8, updateable: true, dbField: 'pvpr' },
  division: {
    show: true,
    required: false,
    order: 9,
    updateable: true,
    dbField: 'division_id',
  },
  gender: {
    show: true,
    required: false,
    order: 10,
    updateable: true,
    dbField: 'gender_id',
  },
  season: {
    show: true,
    required: false,
    order: 11,
    updateable: true,
    dbField: 'season_id',
  },
  segmentation: {
    show: false,
    required: false,
    order: 12,
    updateable: true,
    dbField: 'segmentation_id',
  },
  family: {
    show: false,
    required: false,
    order: 13,
    updateable: true,
    dbField: 'family_id',
  },
  material: {
    show: false,
    required: false,
    order: 14,
    updateable: true,
    dbField: 'material_id',
  },
};

const body: IgetCatalogReferencesAPIBody = {
  // order: [],
  order: ['product_id', 'DESC'],
  index: 0,
  limit: 10,
  filter: {
    brand_id: {
      value: '',
      operator: '=',
    },
  },
};

const initialCatalogUpdateReferencesState: IInitialCatalogUpdateReferencesState = {
  catalogBodyFetch: body,
  getCatalogItems: () => Promise.resolve(false),
  catalogItems: {
    count: 0,
    total: 0,
    data: [],
  },
  isLoadingCatalog: false,
  getFilters: () => Promise.resolve(false),
  filters: null,
  isLoadingGetFilters: false,
  searchOnCatalogItems: () => Promise.resolve(false),
  handlePagination: () => Promise.resolve(false),
  selectedValues: [],
  setSelectedValues: () => {},
  updateReferences: () => Promise.resolve(false),
  isLoadingUpdateReferences: false,
  // Columns
  columnsOrder: initialColumnsOrder,
  moveColumnsOrder: () => {},
  checkColumn: () => {},
};

export default initialCatalogUpdateReferencesState;
